var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from "react";
import History from "@irati/utils/history";
import Loader from "@irati/ui/src/Loading/Loader";
import session from "@irati/auth/services/session";
import internalTracking from "@irati-tracking/internal";
import OnboardingService from "@irati/onboarding/services/onboarding";
import ghostLoginService from "@irati/auth/services/ghostUserLogin";
import loginService from "@irati/auth/services/login";
import authentication from "@irati/auth";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import { getSupportedLocale } from "@irati/utils/lang";
var Ghost = /** @class */ (function (_super) {
    __extends(Ghost, _super);
    function Ghost() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.login = function () { return __awaiter(_this, void 0, void 0, function () {
            var accessToken, hasAdminAccess;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loginService.logout()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, session.getThenRemove(["accessToken"])];
                    case 2:
                        accessToken = (_a.sent()).accessToken;
                        if (!accessToken) {
                            throw new Error("Missing data");
                        }
                        return [4 /*yield*/, ghostLoginService.login(accessToken)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.showUserWarning()];
                    case 4:
                        _a.sent();
                        internalTracking.ghostLogin();
                        hasAdminAccess = authentication.apps("admin");
                        if (!hasAdminAccess) {
                            return [2 /*return*/, this.redirectUser()];
                        }
                        return [2 /*return*/, this.redirectAdmin()];
                }
            });
        }); };
        _this.redirectUser = function () {
            return History.push({ pathname: "/" });
        };
        _this.redirectAdmin = function () { return __awaiter(_this, void 0, void 0, function () {
            var tenantOnboarding, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OnboardingService.getTenantOnboarding()];
                    case 1:
                        tenantOnboarding = _a.sent();
                        if (tenantOnboarding && tenantOnboarding.enabled && !tenantOnboarding.onboardingFinished) {
                            return [2 /*return*/, History.push({ pathname: "/setup-tenant" })];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3:
                        History.push({ pathname: "/admin" });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.showUserWarning = function () { return __awaiter(_this, void 0, void 0, function () {
            var user, confirmed, userLocale;
            return __generator(this, function (_a) {
                user = authentication.user();
                if (user.uuid !== "ghost") {
                    confirmed = confirm("You are ghosting as '" + firstnameLastname(user) + "', anything you do will appear as if they did it. Continue?");
                    if (!confirmed) {
                        window.close();
                    }
                }
                if (user.uuid === "ghost") {
                    userLocale = authentication.userLocale();
                    if (userLocale === "fr") {
                        userLocale = "fr-FR";
                    }
                    if (userLocale !== getSupportedLocale(userLocale)) {
                        alert("Your browser is not set to a supported language, it must be set to 'en-GB', 'fr-FR' or 'en-AU' for ghosting.\n\nIf you are having trouble setting your language to the above, google should be able to help.\n        ");
                        window.close();
                    }
                }
                return [2 /*return*/];
            });
        }); };
        _this.failed = function (error) {
            console.warn("ghost user login errored", error);
            History.push({
                pathname: "/"
            });
        };
        return _this;
    }
    Ghost.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.login()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        this.failed(e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Ghost.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h1", { className: "center" }, "Loading ghost user..."),
            React.createElement(Loader, null)));
    };
    return Ghost;
}(Component));
export default Ghost;
